import MultiLangsInterface from 'app/interfaces/MultiLangsInterface';

interface Langs {
    langs: MultiLangsInterface
}

export const langsValue = (obj: Langs, key: string): string => obj.langs[window.CURRENT_LOCALE] || obj[key];
